// @ts-nocheck -- Legacy JavaScript compatibility boundary; runtime behavior intentionally preserved.
import { useEffect, useRef, useState, isValidElement, cloneElement, Children } from "react";
import PropTypes from "prop-types";

export function Map({ latitude, longitude, zoom, markers, height, width, children }: any) {
  const ref = useRef(null);
  const [map, setMap] = useState(null);

  useEffect(() => {
    if (ref.current && !map) {
      setMap(
        new window.google.maps.Map(ref.current, {
          zoomControl: true,
          mapTypeControl: false,
          streetViewControl: false,
          center: {
            lat: latitude ?? 0,
            lng: longitude ?? 0,
          },
          markers,
          zoom: zoom ?? 10,
        })
      );
    }
  }, [ref, map, latitude, longitude]);

  return (
    <div ref={ref} style={{ height, width }}>
      {Children.map(children, (child) =>
        isValidElement(child) ? cloneElement(child, { map }) : undefined
      )}
    </div>
  );
}

Map.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  markers: PropTypes.arrayOf(
    PropTypes.shape({ latitude: PropTypes.number, longitude: PropTypes.number })
  ),
  zoom: PropTypes.number,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.any,
};
